import { gql } from 'apollo-angular';

export const GET_STATIONARY = gql`
  query stationories($search: String) {
    stationories(search: $search) {
      id
      stationoryName
      stationoryCode
      price
      stock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GET_OPENING_STOCK = gql`
  query getOpeningStock($stationoryId: Int!, $date: String!) {
    getOpeningStock(stationoryId: $stationoryId, date: $date)
  }
`;

export const GET_STATIONARY_LOGS = gql`
  query stationoryLogs($search: String) {
    stationoryLogs(search: $search) {
      id
      stationoryId
      date
      stationoryData {
        id
        stationoryName
        stationoryCode
      }
      openingStock
      closingStock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
